<div class="ribbon-group">
  <div class="ribbon-group-content">
    <!-- <div class="ribbon-button ribbon-button-big">
      <div ngbDropdown class="d-inline-block">
        <button type="button" class="ribbon-button-big-image-container" id="dropdownForm1" ngbDropdownToggle>
          <div class="ribbon-button-big-image-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="currentColor"
              class="bi bi-fullscreen"
              viewBox="0 0 16 16">
              <path
                d="M 1.5 1 C 1.224 1 1 1.224 1 1.5 L 1 5.5 C 1 5.885 0.583 6.125 0.25 5.933 C 0.095 5.844 0 5.679 0 5.5 L 0 1.5 C 0 0.672 0.672 0 1.5 0 L 5.5 0 C 5.885 0 6.125 0.417 5.933 0.75 C 5.844 0.905 5.679 1 5.5 1 L 1.5 1 Z M 15.5 10 C 15.776 10 16 10.224 16 10.5 L 16 14.5 C 16 15.328 15.328 16 14.5 16 L 10.5 16 C 10.115 16 9.875 15.583 10.067 15.25 C 10.156 15.095 10.321 15 10.5 15 L 14.5 15 C 14.776 15 15 14.776 15 14.5 L 15 10.5 C 15 10.224 15.224 10 15.5 10"
                style="fill: rgba(80, 80, 80, 0.8)"></path>
              <g id="SnippetList" transform="matrix(0.587939, 0, 0, 0.587939, 0.670015, 1.098825)" style="">
                <path
                  id="Vector"
                  d="M4 18H14M4 14H20M4 10H14M4 6H20"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  style="stroke-width: 1.70086px"></path>
              </g>
            </svg>
          </div>
          <div class="ribbon-button-big-label-container">
            <p class="ribbon-button-label">
              <span class="ribbon-button-label-text">Insert</span>
              <span class="drop-down-arrow-large">
                <br />
                ▼
              </span>
            </p>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownForm1">
          <form class="px-4 py-3">
            <div class="mb-3">
              <label for="exampleDropdownFormEmail1">Email address</label>
              <input
                type="email"
                class="form-control"
                id="exampleDropdownFormEmail1"
                placeholder="email@example.com"
                autocomplete="username" />
            </div>
            <div class="mb-3">
              <label for="exampleDropdownFormPassword1">Password</label>
              <input
                type="password"
                class="form-control"
                id="exampleDropdownFormPassword1"
                placeholder="Password"
                autocomplete="current-password" />
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="dropdownCheck" />
              <label class="form-check-label" for="dropdownCheck">Remember me</label>
            </div>
            <button type="submit" class="btn btn-primary">Sign in</button>
          </form>
          <div class="dropdown-divider"></div>
          <button type="button" ngbDropdownItem>New around here? Sign up</button>
          <button type="button" ngbDropdownItem>Forgot password?</button>
        </div>
      </div>
    </div> -->
    <!-- <div class="ribbon-button ribbon-button-big" [ngClass]="{ 'txui-state-disabled': !textSelected }"> -->
    <div class="ribbon-button ribbon-button-big">
      <div
        (click)="addSnippet()"
        triggers="hover"
        [openDelay]="300"
        ngbPopover="Preserve pieces of text and easily insert into similar documents.">
        <div class="ribbon-button-big-image-container">
          <svg width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                x1="2.796"
                y1="10.622"
                x2="2.796"
                y2="15.623"
                id="gradient-0"
                spreadMethod="repeat">
                <stop offset="0" style="stop-color: rgb(1.5686% 1.5686% 1.5686% / 0.294)"></stop>
                <stop offset="1" style="stop-color: rgb(0.94118% 0.94118% 0.94118% / 0.294)"></stop>
              </linearGradient>
            </defs>
            <path
              d="M 1.5 1 C 1.224 1 1 1.224 1 1.5 L 1 5.5 C 1 5.885 0.583 6.125 0.25 5.933 C 0.095 5.844 0 5.679 0 5.5 L 0 1.5 C 0 0.672 0.672 0 1.5 0 L 5.5 0 C 5.885 0 6.125 0.417 5.933 0.75 C 5.844 0.905 5.679 1 5.5 1 L 1.5 1 Z M 15.5 10 C 15.776 10 16 10.224 16 10.5 L 16 14.5 C 16 15.328 15.328 16 14.5 16 L 10.5 16 C 10.115 16 9.875 15.583 10.067 15.25 C 10.156 15.095 10.321 15 10.5 15 L 14.5 15 C 14.776 15 15 14.776 15 14.5 L 15 10.5 C 15 10.224 15.224 10 15.5 10"
              style="fill: rgba(80, 80, 80, 0.8)"></path>
            <g id="Edit / Text_Align_Left" transform="matrix(0.587939, 0, 0, 0.587939, 0.670015, 1.098825)" style="">
              <path
                id="Vector"
                d="M4 18H14M4 14H20M4 10H14M4 6H20"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="stroke-width: 1.70086px; stroke: rgb(184, 184, 184)"></path>
            </g>
            <path
              fill-rule="evenodd"
              d="M 3.828 9.001 C 4.179 9.001 4.464 9.287 4.464 9.638 L 4.464 11.547 L 6.373 11.547 C 6.863 11.547 7.169 12.078 6.924 12.502 C 6.81 12.699 6.599 12.82 6.373 12.82 L 4.464 12.82 L 4.464 14.729 C 4.464 15.218 3.933 15.525 3.509 15.279 C 3.312 15.167 3.191 14.956 3.191 14.729 L 3.191 12.82 L 1.282 12.82 C 0.793 12.82 0.486 12.289 0.732 11.865 C 0.844 11.668 1.055 11.547 1.282 11.547 L 3.191 11.547 L 3.191 9.638 C 3.191 9.287 3.477 9.001 3.828 9.001"
              style="
                stroke: rgb(255, 255, 255);
                paint-order: stroke;
                fill: rgba(0, 0, 0, 0.84);
                stroke-width: 1.45px;
              "></path>
          </svg>
        </div>
        <div class="ribbon-button-big-label-container">
          <p class="ribbon-button-label">
            <span class="ribbon-button-label-text">Create</span>
          </p>
        </div>
      </div>
    </div>

    <div
      class="ribbon-button ribbon-button-big"
      ngbDropdown
      #snippetMenu="ngbDropdown"
      [autoClose]="false"
      placement="top-start">
      <div (click)="toggleListMenu()" id="ribbon-txdocs-snippet-list">
        <!-- triggers="hover" [openDelay]="300" ngbPopover="Easily insert preserved text into this documents." -->
        <div class="ribbon-button-big-image-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="currentColor"
            class="bi bi-fullscreen"
            viewBox="0 0 16 16">
            <path
              d="M 1.5 1 C 1.224 1 1 1.224 1 1.5 L 1 5.5 C 1 5.885 0.583 6.125 0.25 5.933 C 0.095 5.844 0 5.679 0 5.5 L 0 1.5 C 0 0.672 0.672 0 1.5 0 L 5.5 0 C 5.885 0 6.125 0.417 5.933 0.75 C 5.844 0.905 5.679 1 5.5 1 L 1.5 1 Z M 15.5 10 C 15.776 10 16 10.224 16 10.5 L 16 14.5 C 16 15.328 15.328 16 14.5 16 L 10.5 16 C 10.115 16 9.875 15.583 10.067 15.25 C 10.156 15.095 10.321 15 10.5 15 L 14.5 15 C 14.776 15 15 14.776 15 14.5 L 15 10.5 C 15 10.224 15.224 10 15.5 10"
              style="fill: rgba(80, 80, 80, 0.8)"></path>
            <g id="SnippetList" transform="matrix(0.587939, 0, 0, 0.587939, 0.670015, 1.098825)" style="">
              <path
                id="Vector"
                d="M4 18H14M4 14H20M4 10H14M4 6H20"
                stroke="#000000"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="stroke-width: 1.70086px"></path>
            </g>
          </svg>
        </div>
        <div class="ribbon-button-big-label-container">
          <p class="ribbon-button-label">
            <span class="ribbon-button-label-text">Insert</span>
            <span class="drop-down-arrow-large">
              <br />
              ▼
            </span>
          </p>
        </div>
      </div>
      <tx-snippet-list-dialog
        style="position: relative"
        idField="id"
        #snippetListDialog
        [menuInstance]="snippetMenu"
        titleField="label"></tx-snippet-list-dialog>
    </div>

    <!-- <div class="ribbon-button-wrapper-small-stacked-buttons">
      <div (click)="toggleInteractive()">
        <div class="ribbon-button ribbon-button-small ribbon-stacked-toggle-button" role="button">
          <div class="ribbon-button ribbon-button-tiny" [ngClass]="{ 'ribbon-button-selected': interactiveMode }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-magic"
              viewBox="0 0 16 16">
              <path
                d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z" />
            </svg>
          </div>
          <div class="ribbon-button-small-label-container">
            <p class="ribbon-button-label"><span class="ribbon-button-label-text">Interactive Mode</span></p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div class="ribbon-group-label-container">
    <p class="ribbon-group-label">Snippets</p>
  </div>
</div>
